<template>
    <form @mousemove.once="onMousemove"
          @touch.once="onTouch"
          @focusin.once="onFocus"
          @submit="onSubmit"
    >
        <slot />
    </form>
</template>

<script>
export default {
    name: "ContactForm",

    data() {
        return {
            hasMoved: false,
            hasTouched: false,
            hasFocused: false,
            hasScrolled: false,
            spambotScoreField: null,
            hasFileSizeError: false,
            submitButton: null,
        };
    },

    mounted() {
        setTimeout(() => {
            // Hide the honeypot field
            const honeypotField = this.$el.querySelector('input#url');
            honeypotField.required = false;
            honeypotField.autocomplete = 'off';
            honeypotField.ariaHidden = 'true';
            honeypotField.previousElementSibling.textContent = 'Merci de laisser ce champ vide'
            honeypotField.parentElement.classList.add('sr-only');
        }, 250);

        this.spambotScoreField = this.$el.querySelector('input[name="message[timestamp]"]');
        this.submitButton = this.$el.querySelector('input[type="submit"]');

        // Add file size validation
        const fileInput = this.$el.querySelector('input[type="file"]');
        if (fileInput) {
            fileInput.addEventListener('change', this.validateFileSize);
        }

        document.addEventListener('scroll', this.onScroll);
    },

    methods: {
        onMousemove() {
            this.hasMoved = true;
        },

        onTouch() {
            this.hasTouched = true;
        },

        onFocus() {
            this.hasFocused = true;
        },

        onScroll() {
            document.removeEventListener('scroll', this.onScroll);

            this.hasScrolled = true;
        },

        validateFileSize(event) {
            const file = event.target.files[0];

            if (!file) {
                this.hasFileSizeError = false;
                this.updateSubmitButton();
                return;
            }

            const maxSizeBytes = 2 * 1024 * 1024; // 2MB

            if (file.size > maxSizeBytes) {
                this.hasFileSizeError = true;

                // Remove existing error messages
                const existingError = document.querySelector('.file-size-error');
                if (existingError) {
                    existingError.remove();
                }

                // Create and display error message
                const errorDiv = document.createElement('div');
                errorDiv.className = 'alert alert-danger file-size-error';
                errorDiv.innerHTML = '<strong>Erreur :</strong> Votre pièce jointe doit peser moins de 2 Mo. ';

                // Insert error message after file input field
                const fileField = event.target.closest('.form-group');
                fileField.parentNode.insertBefore(errorDiv, fileField.nextSibling);

                // Clear the file input
                event.target.value = '';

            } else {
                this.hasFileSizeError = false;

                // Remove error message if file is valid
                const existingError = document.querySelector('.file-size-error');
                if (existingError) {
                    existingError.remove();
                }
            }

            this.updateSubmitButton();
        },

        updateSubmitButton() {
            if (this.submitButton) {
                if (this.hasFileSizeError) {
                    this.submitButton.disabled = true;
                    this.submitButton.value = 'Fichier trop volumineux';
                    this.submitButton.classList.add('btn-secondary');
                    this.submitButton.classList.remove('btn-primary');
                } else {
                    this.submitButton.disabled = false;
                    this.submitButton.value = 'Envoyer';
                    this.submitButton.classList.add('btn-primary');
                    this.submitButton.classList.remove('btn-secondary');
                }
            }
        },

        onSubmit(event) {
            // Prevent submission if file is too large
            if (this.hasFileSizeError) {
                event.preventDefault();
                return false;
            }

            this.spambotScoreField.value = [
                this.hasMoved ? 'M' : 'm',
                this.hasTouched ? 'T' : 't',
                this.hasFocused ? 'F' : 'f',
                this.hasScrolled ? 'S' : 's',
            ].join('');
        },
    },
}
</script>
